$(() => {
    $(document).on('click', (ev) => {
        if($('body').attr('data-intro-active')) return;
        ['popup', 'bar'].forEach((type) => {
            let $target = $(ev.target),
                $popup = $target.closest(`.${type}`),
                $trigger = $target.closest(`.js--trigger-toggle-${type}`);
            if (!$popup.length && !$trigger.length) $(`.${type}_open`).removeClass(`${type}_open`)
        });
    });
});